/* eslint-disable react-hooks/exhaustive-deps */
import {
  useGetCanalDistribuicao,
  useGetCidades,
  useGetContextos,
  useGetEmpresas,
  useGetEstados,
  useGetFamiliaProduto,
  useGetFiliais,
  useGetGrupoProdutos,
  useGetSubGrupoProdutos,
  useGetGrupoSegmentos,
  useGetGruposCentralizadores,
  useGetHierarquiasAprovacao,
  useGetLocais,
  useGetMotivos,
  useGetParametros,
  useGetPesquisaCanalDistribuicao,
  useGetPesquisaEmbalagem,
  useGetPesquisaGrupoMaterial,
  useGetPesquisaGrupoMaterialCanalDistribuicao,
  useGetPesquisaGrupoMaterialEmbalagem,
  useGetPesquisaGrupoMaterialPlayer,
  useGetPesquisaGrupoMaterialPrazo,
  useGetPesquisaGrupoMaterialUnidadeMedida,
  useGetPesquisaPlayer,
  useGetPesquisaPrazos,
  useGetPesquisaProduto,
  useGetPesquisaUnidadeMedidas,
  useGetPrazoPagamentos,
  useGetPrecoCliente,
  useGetPrecoRegra,
  useGetProdutos,
  useGetProdutosFiliais,
  useGetSegmentos,
  useGetServico,
  useGetSimulacoes,
  useGetTipoCondicao,
  useGetTrilhas,
  useGetUnidadeMedidas,
  useGetDocumentos,
  useGetFunilObraGrupoProdutos,
  useGetFunilObraProdutos,
  useGetPesquisaCentroOrigem,
  useGetPesquisaMotivoCompra,
  useGetPesquisaGruposObrigatorios,
  useGetProdutosConcorrente,
  useGetPrazoRegra,
  useGetCargos,
  useGetUltimosUploadsDocumentos,
  useGetPesquisaPlayerCentroOrigem,
  useGetClusters,
  useGetMicrorregiao,
  useGetFunilStatus,
  useGetFunilStatusGrupo,
  useGetTabelaPreco,
  useGetTabelaPrecoCliente,
  useGetRotas,
  useGetMissoes,
  useGetInfosTatica,
  useGetFaturamentos,
  useGetVisitas,
  useGetMapaMina,
  useGetCarteira,
  useGetMotivoPerda,
  useGetFunilObraConcorrente,
  useGetNivelServico,
  useGetFunilObraConsorcio,
  useGetFunilObraEmpresaLider,
  useGetFunilObraFonteCaptacao,
  useGetFunilObraJustificativa,
  useGetGov,
  useGetVendedores,
  useGetLocalTrilhas,
  useGetEquipeVenda,
  useGetEscritorioVenda,
  useGetAreaVendaVendedor,
  useGetReflex,
  useGetPosicaoCarga,
  useGetAutosservico,
  useGetCreditoCliente,
  useGetForcaVenda,
  useGetErroPesquisa,
  useGetErroPesquisaVendedor,
  useGetBateuLevou,
  useGetSuper4,
  useGetVloz,
  useGetPassouGanhou,
  useGetGvFaturamento,
  useGetClienteShare,
  useGetParametroReflex,
  useGetUltimaVisitas,
  useGetDuplaCategoria,
  useGetFunilObraUnidadeMedida,
  useGetFunilObraGrupoProdutoUnidadeMedida,
  useGetFunilObra,
  useGetFunilObraMotivoPerda,
  useGetFunilObraGrupoProdutoMapeamentoInicial
} from "~hooks/useSincronizacao";
import useDefaultFetch from "./useDefaultFetch";
import { db, dbCep } from "~/db/db";
import { useEffect, useMemo, useRef, useState } from "react";
import { useToast } from "@chakra-ui/react";
import { useLiveQuery } from "dexie-react-hooks";
import { useBuscaCEPs } from "~pages/Wallet/hooks/useWallet";
import Dexie from "dexie";
import { registraSincronizacao } from "~services/BackOfficeServices";

const useSincronizacao = (enabled, processLastFetchTime) => {
  const [sincronismos, setSincronismos] = useState([]);
  const [progressBar, setProgressBar] = useState(0);
  const [enableButton, setEnableButton] = useState(true);
  const [activeSincronismo, setActiveSincronismo] = useState("");
  const sincronizacaoIniciadaRef = useRef(false);
  const sincronizacaoFinalizadaRef = useRef(false);

  const toast = useToast();

  const { loading: loadingFunilStatus, finished: finishedFunilStatus } = useDefaultFetch({
    useGet: useGetFunilStatus,
    table: "funilStatus",
    enabled: enabled,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingFunilStatusGrupo, finished: finishedFunilStatusGrupo } = useDefaultFetch({
    useGet: useGetFunilStatusGrupo,
    table: "funilStatusGrupo",
    enabled: enabled && finishedFunilStatus,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingFunilObraFonteCaptacao, finished: finishedFunilObraFonteCaptacao } = useDefaultFetch({
    useGet: useGetFunilObraFonteCaptacao,
    table: "funilObraFonteCaptacao",
    enabled: enabled && finishedFunilStatusGrupo,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingFunilObraJustificativa, finished: finishedFunilObraJustificativa } = useDefaultFetch({
    useGet: useGetFunilObraJustificativa,
    table: "funilObraJustificativas",
    enabled: enabled && finishedFunilObraFonteCaptacao,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingFunilObraUnidadeMedida, finished: finishedFunilObraUnidadeMedida } = useDefaultFetch({
    useGet: useGetFunilObraUnidadeMedida,
    table: "funilObraUnidadeMedidas",
    enabled: enabled && finishedFunilObraJustificativa,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingFunilObraGrupoProdutoUnidadeMedida, finished: finishedFunilObraGrupoProdutoUnidadeMedida } = useDefaultFetch({
    useGet: useGetFunilObraGrupoProdutoUnidadeMedida,
    table: "funilObraGrupoProdutoUnidadeMedida",
    enabled: enabled && finishedFunilObraUnidadeMedida,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingFunilObraMotivoPerda, finished: finishedFunilObraMotivoPerda } = useDefaultFetch({
    useGet: useGetFunilObraMotivoPerda,
    table: "funilObraMotivoPerda",
    enabled: enabled && finishedFunilObraGrupoProdutoUnidadeMedida,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingFunilObraGrupoProdutoMapeamentoInicial, finished: finishedFunilObraGrupoProdutoMapeamentoInicial } = useDefaultFetch({
    useGet: useGetFunilObraGrupoProdutoMapeamentoInicial,
    table: "funilObraGrupoProdutoMapeamentoInicial",
    enabled: enabled && finishedFunilObraMotivoPerda,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingCarteira, finished: finishedCarteira } = useDefaultFetch({
    useGet: useGetCarteira,
    table: "cliente",
    enabled: enabled && finishedFunilObraGrupoProdutoMapeamentoInicial,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

    const { loading: loadingReflex, finished: finishedReflex } = useDefaultFetch({
    useGet: useGetReflex,
    table: "reflex",
    enabled: enabled && finishedCarteira,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true,
  });

  const { loading: loadingPosicaoCarga, finished: finishedPosicaoCarga } = useDefaultFetch({
    useGet: useGetPosicaoCarga,
    table: "posicaoCarga",
    enabled: enabled && finishedReflex,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true,
  });


  const { loading: loadingParametroReflex, finished: finishedParametroReflex } = useDefaultFetch({
    useGet: useGetParametroReflex,
    table: "parametroReflex",
    enabled: enabled && finishedPosicaoCarga,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true,
  });

  const { loading: loadingTrilha, finished: finishedTrilha } = useDefaultFetch({
    useGet: useGetTrilhas,
    table: "trilhas",
    enabled: enabled &&  finishedParametroReflex,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });
  const { loading: loadingEquipeVenda, finished: finishedEquipeVenda } = useDefaultFetch({
    useGet: useGetEquipeVenda,
    table: "equipesVenda",
    enabled: enabled && finishedTrilha,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingEscritorioVenda, finished: finishedEscritorioVenda } = useDefaultFetch({
    useGet: useGetEscritorioVenda,
    table: "escritoriosVenda",
    enabled: enabled && finishedEquipeVenda,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingAreaVendaVendedor, finished: finishedAreaVendaVendedor } = useDefaultFetch({
    useGet: useGetAreaVendaVendedor,
    table: "areasVendaVendedor",
    enabled: enabled && finishedEscritorioVenda,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingAutosservico, finished: finishedAutosservico } = useDefaultFetch({
    useGet: useGetAutosservico,
    table: "autosservico",
    enabled: enabled && finishedAreaVendaVendedor,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true,
  });

  const { loading: loadingCreditoCliente, finished: finishedCreditoCliente } = useDefaultFetch({
    useGet: useGetCreditoCliente,
    table: "creditoCliente",
    enabled: enabled && finishedAutosservico,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true,
  });

  const { loading: loadingForcaVenda, finished: finishedForcaVenda } = useDefaultFetch({
    useGet: useGetForcaVenda,
    table: "forcaVenda",
    enabled: enabled && finishedCreditoCliente,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true,
  });

  const { loading: loadingErroPesquisa, finished: finishedErroPesquisa } = useDefaultFetch({
    useGet: useGetErroPesquisa,
    table: "erroPesquisa",
    enabled: enabled && finishedForcaVenda,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true,
  });

  const { loading: loadingErroPesquisaVendedor, finished: finishedErroPesquisaVendedor } = useDefaultFetch({
    useGet: useGetErroPesquisaVendedor,
    table: "erroPesquisaVendedor",
    enabled: enabled && finishedErroPesquisa,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true,
  });

  const { loading: loadingBateuLevou, finished: finishedBateuLevou } = useDefaultFetch({
    useGet: useGetBateuLevou,
    table: "bateuLevou",
    enabled: enabled && finishedErroPesquisaVendedor,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true,
  });

  const { loading: loadingSuper4, finished: finishedSuper4 } = useDefaultFetch({
    useGet: useGetSuper4,
    table: "super4",
    enabled: enabled && finishedBateuLevou,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true,
  });

  const { loading: loadingVloz, finished: finishedVloz } = useDefaultFetch({
    useGet: useGetVloz,
    table: "vloz",
    enabled: enabled && finishedSuper4,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true,
  });

  const { loading: loadingPassouGanhou, finished: finishedPassouGanhou } = useDefaultFetch({
    useGet: useGetPassouGanhou,
    table: "passouGanhou",
    enabled: enabled && finishedVloz,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true,
  });

  const { loading: loadingGvFaturamento, finished: finishedGvFaturamento } = useDefaultFetch({
    useGet: useGetGvFaturamento,
    table: "gvFaturamento",
    enabled: enabled && finishedPassouGanhou,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true,
  });

  const { loading: loadingClienteShare, finished: finishedClienteShare } = useDefaultFetch({
    useGet: useGetClienteShare,
    table: "clienteShare",
    enabled: enabled && finishedGvFaturamento,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true,
  });

  const { loading: loadingMotivoPerda, finished: finishedMotivoPerda } = useDefaultFetch({
    useGet: useGetMotivoPerda,
    table: "motivosPerda",
    enabled: enabled && finishedClienteShare,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingFunilObraConcorrente, finished: finishedFunilObraConcorrente } = useDefaultFetch({
    useGet: useGetFunilObraConcorrente,
    table: "funilObraConcorrente",
    enabled: enabled && finishedMotivoPerda,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingFunilObraConsorcio, finished: finishedFunilObraConsorcio } = useDefaultFetch({
    useGet: useGetFunilObraConsorcio,
    table: "funilObraConsorcio",
    enabled: enabled && finishedFunilObraConcorrente,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingFunilObraEmpresaLider, finished: finishedFunilObraEmpresaLider } = useDefaultFetch({
    useGet: useGetFunilObraEmpresaLider,
    table: "funilObraEmpresasLider",
    enabled: enabled && finishedFunilObraConsorcio,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingNivelServico, finished: finishedNivelServico } = useDefaultFetch({
    useGet: useGetNivelServico,
    table: "niveisServico",
    enabled: enabled && finishedFunilObraEmpresaLider,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingCargo, finished: finishedCargo } = useDefaultFetch({
    useGet: useGetCargos,
    table: "cargos",
    enabled: enabled && finishedNivelServico,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingCluster, finished: finishedCluster } = useDefaultFetch({
    useGet: useGetClusters,
    table: "cluster",
    enabled: enabled && finishedCargo,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingMicrorregiao, finished: finishedMicrorregiao } = useDefaultFetch({
    useGet: useGetMicrorregiao,
    table: "microrregiao",
    enabled: enabled && finishedCluster,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingProdutoConcorrente, finished: finishedProdutoConcorrente } = useDefaultFetch({
    useGet: useGetProdutosConcorrente,
    table: "produtosConcorrente",
    enabled: enabled && finishedMicrorregiao,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingCanalDistribuicao, finished: finishedCanalDistribuicao } = useDefaultFetch({
    useGet: useGetCanalDistribuicao,
    table: "canaisDistribuicao",
    enabled: enabled && finishedProdutoConcorrente,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingCidades, finished: finishedCidades } = useDefaultFetch({
    useGet: useGetCidades,
    table: "cidades",
    enabled: enabled && finishedCanalDistribuicao,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingContextos, finished: finishedContextos } = useDefaultFetch({
    useGet: useGetContextos,
    table: "contexto",
    enabled: enabled && finishedCidades,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingEmpresas, finished: finishedEmpresas } = useDefaultFetch({
    useGet: useGetEmpresas,
    table: "empresas",
    enabled: enabled && finishedContextos,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingEstados, finished: finishedEstados } = useDefaultFetch({
    useGet: useGetEstados,
    table: "estados",
    enabled: enabled && finishedEmpresas,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingFamiliaProduto, finished: finishedFamiliaProduto } = useDefaultFetch({
    useGet: useGetFamiliaProduto,
    table: "familiaProdutos",
    enabled: enabled && finishedEstados,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingFiliais, finished: finishedFiliais } = useDefaultFetch({
    useGet: useGetFiliais,
    table: "filiais",
    enabled: enabled && finishedFamiliaProduto,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingGruposCentralizadores, finished: finishedGruposCentralizadores } = useDefaultFetch({
    useGet: useGetGruposCentralizadores,
    table: "grupoCentralizador",
    enabled: enabled && finishedFiliais,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingGrupoProdutos, finished: finishedGrupoProdutos } = useDefaultFetch({
    useGet: useGetGrupoProdutos,
    table: "grupoProdutos",
    enabled: enabled && finishedGruposCentralizadores,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingSubGrupoProdutos, finished: finishedSubGrupoProdutos } = useDefaultFetch({
    useGet: useGetSubGrupoProdutos,
    table: "subGrupoMaterial",
    enabled: enabled && finishedGrupoProdutos,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingGrupoSegmentos, finished: finishedGrupoSegmentos } = useDefaultFetch({
    useGet: useGetGrupoSegmentos,
    table: "grupoSegmento",
    enabled: enabled && finishedSubGrupoProdutos,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingLocais, finished: finishedLocais } = useDefaultFetch({
    useGet: useGetLocais,
    table: "local",
    enabled: enabled && finishedGrupoSegmentos,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingLocalTrilhas, finished: finishedLocalTrilhas } = useDefaultFetch({
    useGet: useGetLocalTrilhas,
    table: "localTrilha",
    enabled: enabled && finishedLocais,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingPrazoPagamentos, finished: finishedPrazoPagamentos } = useDefaultFetch({
    useGet: useGetPrazoPagamentos,
    table: "prazoPagamento",
    enabled: enabled && finishedLocalTrilhas,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingSimulacoes, finished: finishedSimulacoes } = useDefaultFetch({
    useGet: useGetSimulacoes,
    table: "simulacoes",
    enabled: enabled && finishedPrazoPagamentos,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingTipoCondicao, finished: finishedTipoCondicao } = useDefaultFetch({
    useGet: useGetTipoCondicao,
    table: "tipoCondicao",
    enabled: enabled && finishedSimulacoes,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingSegmentos, finished: finishedSegmentos } = useDefaultFetch({
    useGet: useGetSegmentos,
    table: "segmento",
    enabled: enabled && finishedTipoCondicao,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingUnidadeMedidas, finished: finishedUnidadeMedidas } = useDefaultFetch({
    useGet: useGetUnidadeMedidas,
    table: "unidadeMedidas",
    enabled: enabled && finishedSegmentos,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingMotivos, finished: finishedMotivos } = useDefaultFetch({
    useGet: useGetMotivos,
    table: "motivo",
    enabled: enabled && finishedUnidadeMedidas,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingParametros, finished: finishedParametros } = useDefaultFetch({
    useGet: useGetParametros,
    table: "parametros",
    enabled: enabled && finishedMotivos,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingHierarquiasAprovacao, finished: finishedHierarquiasAprovacao } = useDefaultFetch({
    useGet: useGetHierarquiasAprovacao,
    table: "hierarquiasAprovacao",
    enabled: enabled && finishedParametros,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const pesquisaSyncEnabled = enabled && finishedHierarquiasAprovacao;

  const { loading: loadingPesquisaCanalDistribuicao, finished: finishedPesquisaCanalDistribuicao } = useDefaultFetch({
    useGet: useGetPesquisaCanalDistribuicao,
    table: "pesquisaCanalDistribuicao",
    enabled: pesquisaSyncEnabled,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingPesquisaGrupoMaterialCanalDistribuicao, finished: finishedPesquisaGrupoMaterialCanalDistribuicao } = useDefaultFetch({
    useGet: useGetPesquisaGrupoMaterialCanalDistribuicao,
    table: "pesquisaGrupoMaterialCanalDistribuicao",
    enabled: pesquisaSyncEnabled,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingPesquisaMedidas, finished: finishedPesquisaMedidas } = useDefaultFetch({
    useGet: useGetPesquisaUnidadeMedidas,
    table: "pesquisaMedidas",
    enabled: pesquisaSyncEnabled,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingPesquisaPlayers, finished: finishedPesquisaPlayers } = useDefaultFetch({
    useGet: useGetPesquisaPlayer,
    table: "pesquisaPlayers",
    enabled: pesquisaSyncEnabled,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingPesquisaGrupoMaterialPlayer, finished: finishedPesquisaGrupoMaterialPlayer } = useDefaultFetch({
    useGet: useGetPesquisaGrupoMaterialPlayer,
    table: "pesquisaGrupoMaterialPlayer",
    enabled: pesquisaSyncEnabled,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingPesquisaPrazos, finished: finishedPesquisaPrazos } = useDefaultFetch({
    useGet: useGetPesquisaPrazos,
    table: "pesquisaPrazos",
    enabled: pesquisaSyncEnabled,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingPesquisaGrupoMaterialPrazo, finished: finishedPesquisaGrupoMaterialPrazo } = useDefaultFetch({
    useGet: useGetPesquisaGrupoMaterialPrazo,
    table: "pesquisaGrupoMaterialPrazo",
    enabled: pesquisaSyncEnabled,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingPesquisaProdutos, finished: finishedPesquisaProdutos } = useDefaultFetch({
    useGet: useGetPesquisaProduto,
    table: "pesquisaProdutos",
    enabled: pesquisaSyncEnabled,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingPesquisaEmbalagem, finished: finishedPesquisaEmbalagem } = useDefaultFetch({
    useGet: useGetPesquisaEmbalagem,
    table: "pesquisaEmbalagem",
    enabled: pesquisaSyncEnabled,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingPesquisaGrupoMaterial, finished: finishedPesquisaGrupoMaterial } = useDefaultFetch({
    useGet: useGetPesquisaGrupoMaterial,
    table: "pesquisaGrupoMaterial",
    enabled: pesquisaSyncEnabled,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingPesquisaGrupoMaterialUnidadeMedida, finished: finishedPesquisaGrupoMaterialUnidadeMedida } = useDefaultFetch({
    useGet: useGetPesquisaGrupoMaterialUnidadeMedida,
    table: "pesquisaGrupoMaterialUnidadeMedida",
    enabled: pesquisaSyncEnabled,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingPesquisaGrupoMaterialEmbalagem, finished: finishedPesquisaGrupoMaterialEmbalagem } = useDefaultFetch({
    useGet: useGetPesquisaGrupoMaterialEmbalagem,
    table: "pesquisaGrupoMaterialEmbalagem",
    enabled: pesquisaSyncEnabled,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingPesquisaCentroOrigem, finished: finishedPesquisaCentroOrigem } = useDefaultFetch({
    useGet: useGetPesquisaCentroOrigem,
    table: "pesquisaCentroOrigem",
    enabled: pesquisaSyncEnabled,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingPesquisaMotivoCompra, finished: finishedPesquisaMotivoCompra } = useDefaultFetch({
    useGet: useGetPesquisaMotivoCompra,
    table: "pesquisaMotivoCompra",
    enabled: pesquisaSyncEnabled,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingPesquisaGruposObrigatorios, finished: finishedPesquisaGruposObrigatorios } = useDefaultFetch({
    useGet: useGetPesquisaGruposObrigatorios,
    table: "pesquisaGruposObrigatorios",
    enabled: pesquisaSyncEnabled,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingPesquisaPlayerCentroOrigem, finished: finishedPesquisaPlayerCentroOrigem } = useDefaultFetch({
    useGet: useGetPesquisaPlayerCentroOrigem,
    table: "pesquisaPlayerCentroOrigem",
    enabled: pesquisaSyncEnabled,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const finishedPesquisaSync =
    finishedPesquisaCanalDistribuicao &&
    finishedPesquisaGrupoMaterialCanalDistribuicao &&
    finishedPesquisaMedidas &&
    finishedPesquisaPlayers &&
    finishedPesquisaGrupoMaterialPlayer &&
    finishedPesquisaPrazos &&
    finishedPesquisaGrupoMaterialPrazo &&
    finishedPesquisaProdutos &&
    finishedPesquisaEmbalagem &&
    finishedPesquisaGrupoMaterial &&
    finishedPesquisaGrupoMaterialUnidadeMedida &&
    finishedPesquisaGrupoMaterialEmbalagem &&
    finishedPesquisaCentroOrigem &&
    finishedPesquisaMotivoCompra &&
    finishedPesquisaGruposObrigatorios &&
    finishedPesquisaPlayerCentroOrigem;

  const { loading: loadingFunilObraGrupoProdutos, finished: finishedFunilObraGrupoProdutos } = useDefaultFetch({
    useGet: useGetFunilObraGrupoProdutos,
    table: "funilObraGrupoProdutos",
    enabled: enabled && finishedPesquisaSync,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  })

  const { loading: loadingFunilObraProdutos, finished: finishedFunilObraProdutos } = useDefaultFetch({
    useGet: useGetFunilObraProdutos,
    table: "funilObraProdutos",
    enabled: enabled && finishedFunilObraGrupoProdutos,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  })

  const { loading: loadingFunilObra, finished: finishedFunilObra } = useDefaultFetch({
    useGet: useGetFunilObra,
    table: "funilObra",
    enabled: enabled && finishedFunilObraProdutos,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  })

  const { loading: loadingPrazoRegra, finished: finishedPrazoRegra } = useDefaultFetch({
    useGet: useGetPrazoRegra,
    table: "prazoRegra",
    enabled: enabled && finishedFunilObra,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const operacionaisSyncEnabled = enabled && finishedPrazoRegra;

  const { loading: loadingVisitas, finished: finishedVisitas } = useDefaultFetch({
    useGet: useGetVisitas,
    table: "visitas",
    enabled: operacionaisSyncEnabled,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  })

   const { loading: loadingUltimaVisita, finished: finishedUltimaVisita } = useDefaultFetch({
    useGet: useGetUltimaVisitas,
    table: "ultimaVisita",
    enabled: operacionaisSyncEnabled,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  })

  const { loading: loadingRotas, finished: finishedRotas } = useDefaultFetch({
    useGet: useGetRotas,
    table: "rotas",
    enabled: operacionaisSyncEnabled,
    processLastFetchTime,
    clear: true,
    setActiveSincronismo,
  })

  const { loading: loadingMissoes, finished: finishedMissoes } = useDefaultFetch({
    useGet: useGetMissoes,
    table: "missoes",
    enabled: operacionaisSyncEnabled,
    processLastFetchTime,
    clear: true,
    setActiveSincronismo,
  })

  const { loading: loadingDuplaCategoria, finished: finishedDuplaCategoria } = useDefaultFetch({
    useGet: useGetDuplaCategoria,
    table: "duplaCategoria",
    enabled: operacionaisSyncEnabled,
    processLastFetchTime,
    clear: true,
    setActiveSincronismo,
  })

  const { loading: loadingInfosTatica, finished: finishedInfosTatica } = useDefaultFetch({
    useGet: useGetInfosTatica,
    table: "infosTatica",
    enabled: operacionaisSyncEnabled,
    processLastFetchTime,
    clear: true,
    setActiveSincronismo,
  })

  const { loading: loadingFaturamentos, finished: finishedFaturamentos } = useDefaultFetch({
    useGet: useGetFaturamentos,
    table: "faturamentos",
    enabled: operacionaisSyncEnabled,
    processLastFetchTime,
    clear: true,
    setActiveSincronismo,
  })

  const { loading: loadingGovs, finished: finishedGovs } = useDefaultFetch({
    useGet: useGetGov,
    table: "govs",
    enabled: operacionaisSyncEnabled,
    processLastFetchTime,
    clear: true,
    setActiveSincronismo,
  })

  const finishedOperacionaisSync =
    finishedVisitas &&
    finishedUltimaVisita &&
    finishedRotas &&
    finishedMissoes &&
    finishedDuplaCategoria &&
    finishedInfosTatica &&
    finishedFaturamentos &&
    finishedGovs;

  const { loading: loadingProdutosFiliais, finished: finishedProdutosFiliais } = useDefaultFetch({
    useGet: useGetProdutosFiliais,
    table: "produtosFiliais",
    enabled: enabled && finishedOperacionaisSync,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const comercialSyncEnabled = enabled && finishedOperacionaisSync;


  const { loading: loadingPrecoCliente, finished: finishedPrecoCliente } = useDefaultFetch({
    useGet: useGetPrecoCliente,
    table: "precosCliente",
    enabled: comercialSyncEnabled,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingPrecoRegra, finished: finishedPrecoRegra } = useDefaultFetch({
    useGet: useGetPrecoRegra,
    table: "tabelaPreco",
    enabled: comercialSyncEnabled,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });


  const { loading: loadingServico, finished: finishedServico } = useDefaultFetch({
    useGet: useGetServico,
    table: "servico",
    enabled: comercialSyncEnabled,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingProdutos, finished: finishedProdutos } = useDefaultFetch({
    useGet: useGetProdutos,
    table: "produtos",
    enabled: comercialSyncEnabled,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });


  const { loading: loadingTabelaPrecoCliente, finished: finishedTabelaPrecoCliente } = useDefaultFetch({
    useGet: useGetTabelaPrecoCliente,
    table: "tabelaPrecoCliente",
    enabled: comercialSyncEnabled,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingDocumentos, finished: finishedDocumentos } = useDefaultFetch({
    useGet: useGetDocumentos,
    table: "documentos",
    enabled: comercialSyncEnabled,
    processLastFetchTime,
    setActiveSincronismo,
    incremental: true
  });

  const finishedComercialSync =
    finishedProdutosFiliais &&
    finishedPrecoCliente &&
    finishedPrecoRegra &&
    finishedServico &&
    finishedProdutos &&
    finishedTabelaPrecoCliente &&
    finishedDocumentos;

  const { loading: loadingUltimosUploadsDocumentos, finished: finishedUltimosUploadsDocumentos } = useDefaultFetch({
    useGet: useGetUltimosUploadsDocumentos,
    table: "ultimosUploadsDocumentos",
    enabled: enabled && finishedComercialSync,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingMapaDaMina, finished: finishedMapaDaMina } = useDefaultFetch({
    useGet: useGetMapaMina,
    table: "mapaDaMinaOriginal",
    enabled: enabled && finishedUltimosUploadsDocumentos,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  const { loading: loadingCep, finished: finishedCep } = useDefaultFetch({
    useGet: useBuscaCEPs,
    table: "cep",
    enabled: enabled && finishedComercialSync,
    processLastFetchTime,
    setActiveSincronismo,
    clear: true
  });

  useEffect(() => {
    const fetchSincronismos = async () => {
      const sincronismos = [];
      try {
        await db.sincronizacao.each((sincronismo) => {
          sincronismos.push({ ...sincronismo, checked: false });
        });
        setSincronismos(sincronismos);
      }
      catch (error) {
        console.log(error);
        localStorage.removeItem('last-fetch-datetime-new');
        db.delete();
        window.location.reload();
        return null;
      }
    };

    fetchSincronismos();
  }, []);

  const allLoadings = useMemo(() => [
    loadingCep,
    loadingTrilha,
    loadingCanalDistribuicao,
    loadingProdutoConcorrente,
    loadingCargo,
    loadingFunilStatus,
    loadingFunilStatusGrupo,
    loadingFunilObraUnidadeMedida,
    loadingFunilObraGrupoProdutoUnidadeMedida,
    loadingTabelaPrecoCliente,
    loadingCarteira,
    loadingReflex,
    loadingPosicaoCarga,
    loadingParametroReflex,
    loadingCluster,
    loadingMicrorregiao,
    loadingCidades,
    loadingContextos,
    loadingEmpresas,
    loadingEstados,
    loadingFamiliaProduto,
    loadingFiliais,
    loadingGruposCentralizadores,
    loadingGrupoProdutos,
    loadingSubGrupoProdutos,
    loadingGrupoSegmentos,
    loadingLocais,
    loadingLocalTrilhas,
    loadingPrazoPagamentos,
    loadingPrecoCliente,
    loadingPrecoRegra,
    loadingProdutos,
    loadingProdutosFiliais,
    loadingSegmentos,
    loadingServico,
    loadingSimulacoes,
    loadingTipoCondicao,
    loadingHierarquiasAprovacao,
    loadingUnidadeMedidas,
    loadingMotivos,
    loadingParametros,
    loadingPesquisaCanalDistribuicao,
    loadingPesquisaGrupoMaterialCanalDistribuicao,
    loadingPesquisaMedidas,
    loadingPesquisaPlayers,
    loadingPesquisaGrupoMaterialPlayer,
    loadingPesquisaPrazos,
    loadingPesquisaGrupoMaterialPrazo,
    loadingPesquisaProdutos,
    loadingPesquisaGrupoMaterial,
    loadingPesquisaGrupoMaterialUnidadeMedida,
    loadingPesquisaGrupoMaterialEmbalagem,
    loadingPesquisaEmbalagem,
    loadingPesquisaCentroOrigem,
    loadingPesquisaMotivoCompra,
    loadingPesquisaGruposObrigatorios,
    loadingPesquisaPlayerCentroOrigem,
    loadingDocumentos,
    loadingFunilObra,
    loadingFunilObraGrupoProdutos,
    loadingFunilObraProdutos,
    loadingPrazoRegra,
    loadingUltimosUploadsDocumentos,
    loadingVisitas,
    loadingUltimaVisita,
    loadingRotas,
    loadingMissoes,
    loadingDuplaCategoria,
    loadingInfosTatica,
    loadingFaturamentos,
    loadingGovs,
    loadingMapaDaMina,
    loadingMotivoPerda,
    loadingFunilObraConcorrente,
    loadingNivelServico,
    loadingFunilObraConsorcio,
    loadingFunilObraEmpresaLider,
    loadingFunilObraFonteCaptacao,
    loadingFunilObraJustificativa,
    loadingFunilObraMotivoPerda,
    loadingFunilObraGrupoProdutoMapeamentoInicial,
    loadingEquipeVenda,
    loadingEscritorioVenda,
    loadingAreaVendaVendedor,
    loadingAutosservico,
    loadingCreditoCliente,
    loadingForcaVenda,
    loadingErroPesquisa,
    loadingErroPesquisaVendedor,
    loadingBateuLevou,
    loadingSuper4,
    loadingVloz,
    loadingPassouGanhou,
    loadingGvFaturamento,
    loadingClienteShare
  ], [
    loadingCep,
    loadingTrilha,
    loadingCanalDistribuicao,
    loadingFunilStatus,
    loadingFunilStatusGrupo,
    loadingTabelaPrecoCliente,
    loadingFunilObraUnidadeMedida,
    loadingFunilObraGrupoProdutoUnidadeMedida,
    loadingCarteira,
    loadingReflex,
    loadingPosicaoCarga,
    loadingParametroReflex,
    loadingCargo,
    loadingCluster,
    loadingMicrorregiao,
    loadingProdutoConcorrente,
    loadingCidades,
    loadingContextos,
    loadingEmpresas,
    loadingEstados,
    loadingFamiliaProduto,
    loadingFiliais,
    loadingGruposCentralizadores,
    loadingGrupoProdutos,
    loadingSubGrupoProdutos,
    loadingGrupoSegmentos,
    loadingLocais,
    loadingLocalTrilhas,
    loadingPrazoPagamentos,
    loadingPrecoCliente,
    loadingPrecoRegra,
    loadingProdutos,
    loadingProdutosFiliais,
    loadingSegmentos,
    loadingServico,
    loadingSimulacoes,
    loadingTipoCondicao,
    loadingHierarquiasAprovacao,
    loadingUnidadeMedidas,
    loadingMotivos,
    loadingParametros,
    loadingPesquisaCanalDistribuicao,
    loadingPesquisaGrupoMaterialCanalDistribuicao,
    loadingPesquisaMedidas,
    loadingPesquisaPlayers,
    loadingPesquisaGrupoMaterialPlayer,
    loadingPesquisaPrazos,
    loadingPesquisaGrupoMaterialPrazo,
    loadingPesquisaProdutos,
    loadingPesquisaGrupoMaterial,
    loadingPesquisaGrupoMaterialUnidadeMedida,
    loadingPesquisaGrupoMaterialEmbalagem,
    loadingPesquisaEmbalagem,
    loadingPesquisaCentroOrigem,
    loadingPesquisaMotivoCompra,
    loadingPesquisaGruposObrigatorios,
    loadingPesquisaPlayerCentroOrigem,
    loadingDocumentos,
    loadingFunilObra,
    loadingFunilObraGrupoProdutos,
    loadingFunilObraProdutos,
    loadingPrazoRegra,
    loadingUltimosUploadsDocumentos,
    loadingVisitas,
    loadingUltimaVisita,
    loadingRotas,
    loadingMissoes,
    loadingDuplaCategoria,
    loadingInfosTatica,
    loadingFaturamentos,
    loadingGovs,
    loadingMapaDaMina,
    loadingMotivoPerda,
    loadingFunilObraConcorrente,
    loadingNivelServico,
    loadingFunilObraConsorcio,
    loadingFunilObraEmpresaLider,
    loadingFunilObraFonteCaptacao,
    loadingFunilObraJustificativa,
    loadingFunilObraMotivoPerda,
    loadingFunilObraGrupoProdutoMapeamentoInicial,
    loadingEquipeVenda,
    loadingEscritorioVenda,
    loadingAreaVendaVendedor,
    loadingAutosservico,
    loadingCreditoCliente,
    loadingForcaVenda,
    loadingErroPesquisa,
    loadingErroPesquisaVendedor,
    loadingBateuLevou,
    loadingSuper4,
    loadingVloz,
    loadingPassouGanhou,
    loadingGvFaturamento,
    loadingClienteShare
  ]);

  const loading = useMemo(() => allLoadings.some(Boolean), [allLoadings]);

  const percentage = useMemo(() => {
    const progress = allLoadings.filter((load) => !load).length;
    return Number(((progress / allLoadings.length) * 100).toFixed(0));
  }, [allLoadings]);

  useEffect(() => {
    if (!enabled) {
      sincronizacaoIniciadaRef.current = false;
      sincronizacaoFinalizadaRef.current = false;
      return;
    }

    if (sincronizacaoIniciadaRef.current) {
      return;
    }

    sincronizacaoIniciadaRef.current = true;
    sincronizacaoFinalizadaRef.current = false;

    registraSincronizacao(1).catch((error) => {
      console.error("Erro ao registrar início da sincronização:", error);
    });
  }, [enabled]);

  useEffect(() => {
    if (!enabled || loading || !sincronizacaoIniciadaRef.current || sincronizacaoFinalizadaRef.current) {
      return;
    }

    sincronizacaoFinalizadaRef.current = true;

    registraSincronizacao(2).catch((error) => {
      console.error("Erro ao registrar fim da sincronização:", error);
    });
  }, [enabled, loading]);

  useEffect(() => {
    setProgressBar(percentage);

    if (percentage === 100 && enabled && enableButton) {
      setEnableButton(false);
      toast({
        title: `Dados sincronizados com sucesso`,
        status: "success",
        duration: 9000,
        isClosable: true,
        position: "top-right",
      });
    }
  }, [percentage, enabled, enableButton, toast]);

  useEffect(() => {
    window.dispatchEvent(new CustomEvent("sync-loading-changed", { detail: { loading } }));
  }, [loading]);

  return { sincronismos, setSincronismos, loading, progressBar, enableButton, setEnableButton, activeSincronismo };
};

export default useSincronizacao;
